import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Box, Tabs, Tab } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/auth/LoginForm';
import SignupForm from '../components/auth/SignupForm';
import EmailVerificationRequired from '../components/auth/EmailVerificationRequired';

export default function AuthPage() {
  const { user, emailVerified, pendingVerification, clearPendingVerification, loading } = useAuth();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [activeTab, setActiveTab] = useState(0);

  // Redirect to dashboard if already logged in AND email is verified
  useEffect(() => {
    if (user && user.organizationId && emailVerified && !pendingVerification) {
      navigate('/dashboard');
    }
  }, [user, emailVerified, pendingVerification, navigate]);

  // Show verification screen if user is logged in but email not verified
  const showVerificationScreen = user && !emailVerified && !loading;

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Paper sx={{ p: 4, width: '100%' }}>
          {showVerificationScreen ? (
            <EmailVerificationRequired
              email={user.email || ''}
              onVerified={() => {
                clearPendingVerification();
                enqueueSnackbar('Email verified successfully!', { variant: 'success' });
                navigate('/dashboard');
              }}
              onBack={() => {
                clearPendingVerification();
              }}
            />
          ) : (
            <>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                  value={activeTab}
                  onChange={(_, newValue) => setActiveTab(newValue)}
                  centered
                  aria-label="auth tabs"
                >
                  <Tab label="Sign In" />
                  <Tab label="Sign Up" />
                </Tabs>
              </Box>

              {activeTab === 0 ? (
                <LoginForm onSwitchToSignup={() => setActiveTab(1)} />
              ) : (
                <SignupForm onSwitchToLogin={() => setActiveTab(0)} />
              )}
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
}
